<template>
	<div id="app">
		<BHLoading :show="$store.state.loading" />
		<MediaSelector :multiple="multipleImages" />
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import BHLoading from 'bh-mod/components/common/Loading'
import MediaSelector from 'bh-mod/components/file/MediaSelector'

export default {
	name: 'app',
	components: { MediaSelector, BHLoading },
	computed: {
		...mapGetters(['user']),

		multipleImages() {
			return this.$store.state.appData.multipleImages
		},
	},
	watch: {
		'$route'(to) {
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)

			if (to.path === '/settings') {
				this.$store.commit("SIDEBAR_SELECTION", 'Settings');
			} else if (to.path === '/knowledgeBase') {
				this.$store.commit("SIDEBAR_SELECTION", 'Knowledge Base');
			} else if (to.path === '/') {
				this.$store.commit("SIDEBAR_SELECTION", 'Agents');
			} else if (to.path === '/call-history' && this.$store.getters.isAIAdvanceAddOn) {
				this.$store.commit("SIDEBAR_SELECTION", 'Call History');
			} else {
				this.$store.commit("SIDEBAR_SELECTION", '');
			}
		},
	},
}
</script>
<style lang="scss">
#app {
	min-height: 100vh;
}
</style>
